module.exports = __webpack_public_path__ + "static/media/conventional.3ecf5c08.svg";